import { Inject, Injectable } from '@angular/core';
import { AccountService } from 'src/app/shared/services/account.service';
import { IGenericStorage } from 'src/app/shared/services/contracts/database/generic-storage';
import { IFeathersAppProvider } from 'src/app/shared/services/contracts/sync/feathers-app-provider';
import { DatabaseService } from 'src/app/shared/services/database.service';
import { FeathersService } from 'src/app/shared/services/feathers.service';

import { IRepository } from '../contracts/repository/repository';
import { IPlatformSync, PlatformSyncToken } from '../contracts/sync/platform-sync';
import { IUnitOfWork } from '../contracts/unit-of-work/unit-of-work';
import { IUnitOfWorkFactory } from '../contracts/unit-of-work/unit-of-work-factory';
import { Deferred } from '../deferred/deferred';
import { DBPlugin, PluginsToken } from '../repository/index-plugins';
import { AlbertaStorage } from '../storage/alberta-storage';
import { UnitOfWork } from './unit-of-work';

@Injectable({ providedIn: 'root' })
export class UnitOfWorkFactory implements IUnitOfWorkFactory {
  private _ready: Deferred<void> = new Deferred();
  private _repositories: Record<string, IRepository<any>> = {};
  private _unitOfWork: IUnitOfWork;

  constructor(
    private _dbProvider: DatabaseService,
    @Inject(PluginsToken) private _plugins: Record<string, DBPlugin>,
    @Inject(PlatformSyncToken) private _platformSync: IPlatformSync,
    private _accountService: AccountService,
    @Inject(FeathersService) private _feathersAppProvider: IFeathersAppProvider
  ) {
    this.init();
  }

  private async init() {
    await this._platformSync.ready;

    const storageFactory = this._platformSync.isCordova
      ? async (storage: IGenericStorage) => storage
      : async (storage: IGenericStorage) => {
          const newStorage = new AlbertaStorage(undefined, undefined);
          await newStorage.create();
          return Object.assign(newStorage, storage);
        };

    this._unitOfWork = new UnitOfWork(
      this._dbProvider,
      this._repositories,
      this._plugins,
      storageFactory,
      this._accountService,
      this._feathersAppProvider,
      this._platformSync
    );

    this._ready.resolve();
  }

  async create(): Promise<IUnitOfWork> {
    await this._ready.promise;

    return this._unitOfWork;
  }
}
